// extracted by mini-css-extract-plugin
export var block = "index-module--block--6T6Pu";
export var content = "index-module--content--EGUnN";
export var customerSaying = "index-module--customerSaying--6HATm";
export var quote = "index-module--quote--zY-vu";